"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var react_1 = __importDefault(require("react"));

exports.SVG = function () {
  return react_1["default"].createElement("svg", {
    viewBox: "0 0 20 20",
    fill: "none"
  }, react_1["default"].createElement("path", {
    d: "M10 14C7.791 14 6 12.209 6 10C6 7.791 7.791 6 10 6C12.209 6 14 7.791 14 10C14 12.209 12.209 14 10 14ZM17.558 8.179L16.627 7.714C16.43 7.614 16.334 7.385 16.404 7.176L16.906 5.669C17.002 5.382 16.928 5.064 16.713 4.851L15.149 3.287C14.936 3.072 14.618 2.998 14.331 3.094L12.824 3.596C12.623 3.663 12.381 3.562 12.286 3.373L11.821 2.442C11.686 2.171 11.408 2 11.105 2H8.895C8.592 2 8.314 2.171 8.179 2.442L7.714 3.373C7.614 3.57 7.386 3.666 7.176 3.596L5.949 3.187C5.49 3.034 4.983 3.153 4.642 3.495L3.495 4.642C3.153 4.984 3.034 5.49 3.187 5.949L3.596 7.176C3.666 7.385 3.57 7.614 3.373 7.714L2.442 8.179C2.171 8.314 2 8.592 2 8.895V11.105C2 11.408 2.171 11.686 2.442 11.821L3.39 12.295C3.59 12.395 3.685 12.627 3.611 12.838L3.097 14.322C2.996 14.611 3.07 14.933 3.287 15.149L4.851 16.713C5.064 16.928 5.382 17.002 5.669 16.906C5.669 16.906 6.622 16.583 7.164 16.394C7.376 16.319 7.607 16.414 7.707 16.614L8.13 17.459C8.315 17.831 8.592 18 8.895 18H11.105C11.408 18 11.686 17.829 11.821 17.558L12.286 16.627C12.386 16.43 12.614 16.334 12.824 16.404L14.331 16.906C14.618 17.002 14.936 16.928 15.149 16.713L16.713 15.149C16.928 14.936 17.002 14.618 16.906 14.331L16.404 12.824C16.334 12.614 16.43 12.386 16.627 12.286L17.558 11.821C17.829 11.686 18 11.408 18 11.105V8.895C18 8.592 17.829 8.314 17.558 8.179Z",
    fill: "#727B7F"
  }));
};